/* =============================================================================
   POPUP DOS 10% — o comportamento.

   ⛔ ESTE POPUP NASCE DESLIGADO e assim fica até o Silva o ligar no editor do
   tema. Enquanto a Nortada não entregar o código de desconto, quem trabalha é o
   popup do Klaviyo: um nosso que promete 10% e não cumpre é pior do que nenhum.

   ⚠️ Para o ver sem o ligar a toda a gente: junta `?ver-popup=1` ao endereço.
   Nesse modo ele aparece sempre e NÃO guarda nada, para se poder repetir.
   ========================================================================== */
(function () {
  'use strict';
  var raiz = document.getElementById('ilhaPopup');
  if (!raiz) return;

  var CHAVE = 'ilha_popup_10';
  var PORTA = 'https://contas.ilhadoscosmeticos.pt/subscrever';
  var ensaio = /[?&]ver-popup=1/.test(location.search);

  var caixa = raiz.querySelector('.ilha-pop__caixa'),
      fechar = document.getElementById('ilhaPopupX'),
      /* ⚠️ A saída honesta, por baixo do formulário. Quem não a encontra fecha a
         PÁGINA em vez de fechar o popup, e isso perde a visita toda. */
      recusar = document.getElementById('ilhaPopupNao'),
      campo = document.getElementById('ilhaPopupEmail'),
      botao = document.getElementById('ilhaPopupBt'),
      aviso = document.getElementById('ilhaPopupMsg'),
      textoLegal = document.getElementById('ilhaPopupTexto'),
      formulario = document.getElementById('ilhaPopupForm'),
      rotulo = botao ? (botao.textContent || '').trim() : '';

  /* ⚠️ Tudo o que toca no armazenamento vai em try/catch. Numa janela privada, ou
     com os dados do site bloqueados, ler isto ATIRA — e sem isto o popup deixava
     de aparecer a quem tem o browser assim, sem erro visível nenhum. */
  function lido(onde, chave) {
    try { return window[onde].getItem(chave); } catch (e) { return null; }
  }
  function guardar(onde, chave, valor) {
    try { window[onde].setItem(chave, valor); } catch (e) { /* sem memória, paciência */ }
  }

  function jaChega() {
    if (ensaio) return false;
    if (lido('localStorage', CHAVE)) return true;      // já se inscreveu ou já o fechou
    if (lido('sessionStorage', CHAVE + '_visto')) return true;  // já apareceu nesta visita
    return false;
  }

  function dizer(txt, bem) {
    if (!aviso) return;
    aviso.textContent = txt;
    aviso.hidden = false;
    aviso.className = 'ilha-pop__msg ' + (bem ? 'ok' : 'err');
  }

  /* ⛔⛔ 05/10/2026 · A LETRA DO TÍTULO TEM DE CHEGAR ANTES DA CAIXA.
     Medido no tema no ar, rede lenta: a caixa nasce com 693 px e, quando a letra chega, o
     título passa de 103 px para 68 e a caixa encolhe para 657, descendo 17 px. Não é a
     fotografia (o topo fica nos 263 o tempo todo, dentro de um `aspect-ratio`): é o
     «Cormorant Garamond» do título, servido com `display=swap`, e o popup é a ÚNICA coisa
     da página que usa essa letra.

     ⛔ A PRIMEIRA VERSÃO DISTO PEDIA A LETRA SÓ NO `abrir()`, E A AUDITORIA DERRUBOU-A: a
     739 kbps a letra (61 KB em dois ficheiros) demora mais do que o tecto de espera, e o
     salto voltava igual, precisamente na rede lenta onde ele custa mais. Agora a letra
     pede-se ASSIM QUE SE SABE QUE O POPUP VAI APARECER, que são 8 segundos antes, e o
     `abrir()` só espera pelo que já está a caminho.

     ⚠️ Quem já fechou o popup não paga estes 61 KB: o `jaChega()` sai antes de se pedir.
     ⚠️ Nada disto pode impedir o popup de abrir. Se a letra falhar, se `document.fonts` não
     existir, se o `load()` atirar, se não houver `Promise`: abre à mesma, com a letra de
     reserva, exatamente como abria antes. */
  var aLetraVemAi = null;

  function pedirALetra() {
    if (aLetraVemAi) return aLetraVemAi;
    var relogio = null;
    aLetraVemAi = new Promise(function (pronto) {
      if (!document.fonts || !document.fonts.load) { pronto(); return; }
      /* ⚠️ tecto de 3 s, não de 1,2: o popup espera 8 s na mesma, e a auditoria mostrou que
         1,2 s é curto de mais em rede lenta. Passado o tecto, abre com a de reserva. */
      relogio = setTimeout(pronto, 3000);
      Promise.all([
        document.fonts.load('400 31px "Cormorant Garamond"'),
        document.fonts.load('italic 600 31px "Cormorant Garamond"'),
      ]).then(function () { pronto(); }, function () { pronto(); });
    });
    /* ⭐ limpar o relógio quando já não é preciso: não muda nada para a cliente, só não
       deixa um temporizador pendurado (apontamento da auditoria). */
    aLetraVemAi = aLetraVemAi.then(function () { if (relogio) clearTimeout(relogio); });
    return aLetraVemAi;
  }

  function abrir() {
    /* ⛔ try/catch À VOLTA DE TUDO: um `Promise` que não exista, ou um `load()` que atire em
       vez de rejeitar, fariam o popup NUNCA abrir. O comentário prometia que isso era
       impossível e a auditoria mostrou que não era. */
    try { pedirALetra().then(abrirMesmo, abrirMesmo); }
    catch (e) { abrirMesmo(); }
  }

  function abrirMesmo() {
    /* ⚠️ Tirar o `hidden` CHEGA para ele aparecer — a entrada é uma animação do
       CSS. Já dependeu de um `requestAnimationFrame`, que não corre com o
       separador em segundo plano: o popup ficava invisível e a tapar a página. */
    raiz.hidden = false;
    /* ⚠️ Em modo de ensaio não se guarda NADA, nem a marca da sessão. Guardava, e
       isso fazia com que a segunda vez no mesmo separador já não aparecesse —
       enganava quem estivesse a experimentá-lo. */
    if (!ensaio) guardar('sessionStorage', CHAVE + '_visto', '1');
    if (campo) { try { campo.focus({ preventScroll: true }); } catch (e) {} }
    document.addEventListener('keydown', teclaEscape);
  }

  function sair(porque) {
    raiz.classList.add('a-fechar');
    document.removeEventListener('keydown', teclaEscape);
    setTimeout(function () { raiz.hidden = true; raiz.classList.remove('a-fechar'); }, 220);
    /* ⚠️ Um popup que volta a quem já disse que não é a maneira mais rápida de a
       pessoa deixar de voltar ao site. Por isso o "não" guarda-se para sempre. */
    if (!ensaio) guardar('localStorage', CHAVE, porque || 'fechado');
  }

  function teclaEscape(ev) { if (ev.key === 'Escape') sair('fechado'); }

  function enviar() {
    var mail = (campo.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)) { dizer('Escreve um email válido, por favor.', false); campo.focus(); return; }
    botao.disabled = true; botao.textContent = 'A enviar…';
    fetch(PORTA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: mail,
        origem: 'popup',
        /* ⚠️ A prova sai do ECRÃ, não do código: é a frase que ela mesma leu.
           Se alguém mudar o texto no popup, a prova muda com ele. */
        texto: textoLegal ? (textoLegal.textContent || '').trim() : ''
      })
    }).then(function (r) {
      if (r.status === 201 || r.status === 200) {
        /* ⛔ SEMPRE A MESMA MENSAGEM, e a razão é séria: há pessoas que já
           cancelaram connosco e essas não voltam a entrar nem levam desconto,
           mas o servidor responde 201 na mesma, de propósito. Se aqui
           mostrássemos algo diferente, qualquer um descobria quem está na nossa
           lista, um endereço de cada vez. */
        if (formulario) formulario.hidden = true;
        dizer('Está quase. Vê o teu email para confirmares.', true);
        if (!ensaio) guardar('localStorage', CHAVE, 'subscrito');
        setTimeout(function () { sair('subscrito'); }, 3200);
        return;
      }
      botao.disabled = false; botao.textContent = rotulo;
      if (r.status === 429) { dizer('Já recebemos há pouco. Espera um bocadinho e tenta outra vez.', false); return; }
      dizer('Não foi possível inscrever agora. Tenta daqui a pouco.', false);
    }).catch(function () {
      botao.disabled = false; botao.textContent = rotulo;
      dizer('Não foi possível inscrever agora. Tenta daqui a pouco.', false);
    });
  }

  if (fechar) fechar.addEventListener('click', function () { sair('fechado'); });
  /* ⚠️ "Não preciso de desconto" fecha como o X, e é DE PROPÓSITO que fecha da mesma
     maneira: quem recusa não deve voltar a ver o popup a cada página. */
  if (recusar) recusar.addEventListener('click', function () { sair('recusado'); });
  /* clicar no escuro à volta também fecha, como o do Klaviyo faz */
  raiz.addEventListener('click', function (ev) { if (ev.target === raiz) sair('fechado'); });
  if (botao) botao.addEventListener('click', enviar);
  if (campo) campo.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter') { ev.preventDefault(); enviar(); }
  });

  if (jaChega()) return;
  var espera = parseInt(raiz.getAttribute('data-espera'), 10);
  if (isNaN(espera) || espera < 0) espera = 8;
  /* ⭐ A LETRA PEDE-SE JÁ, não daqui a 8 segundos. É esta linha que faz o reparo aguentar
     a rede lenta: quando a caixa abrir, a letra já cá está e a altura não muda. */
  try { pedirALetra(); } catch (e) {}
  setTimeout(abrir, ensaio ? 300 : espera * 1000);
})();
